export const checkIfTriggerIsUsed = (trigger: number, inputJson: any) => {
  let returnObject = {
    status: false,
    intentId: null
  }

  const checkTrigger = (intent: any, triggerCheck: number) => {
    if (intent.trigger === triggerCheck) {
      returnObject = {
        status: true,
        intentId: intent.id
      }
      return true
    }
    return false
  }

  const checkButtons = (buttons: any[], triggerCheckButton: number) => {
    return buttons.some(
      (button: any) => !!button.action && checkTrigger(button.action, triggerCheckButton)
    )
  }

  const checkPayload = (payload: any[], triggerPayload: number, type: string) => {
    if (type === 'listButtons') {
      return payload[0].elements.some(
        (element: any) => !!element.action && checkTrigger(element.action, triggerPayload)
      )
    } else if (type === 'table' || type === 'ratingAndReview') {
      return checkButtons(payload[0].buttons, triggerPayload)
    } else {
      return payload.some((item: any) => checkTrigger(item, triggerPayload))
    }
  }

  inputJson.some((intent: any) => {
    if (!intent.metadata && !!intent.message && typeof intent.userInput === 'boolean') {
      if (checkTrigger(intent, trigger)) return true
    }

    if (!!intent.metadata?.templateId) {
      const templateId = intent.metadata.templateId
      const payload = intent.metadata.payload

      switch (templateId) {
        case 6:
        case 13:
        case 20:
        case 21:
        case 27:
          if (checkPayload(payload, trigger, 'default')) return true
          break
        case 10:
          if (checkPayload(payload, trigger, 'listButtons')) return true
          break
        case 12:
          if (checkButtons(payload[0].buttons, trigger)) return true
          break
        case 25:
        case 30:
          if (checkPayload(payload, trigger, 'table')) return true
          break
        default:
          return false
      }
    }

    return false
  })

  return returnObject
}
